import React,{useState,useEffect} from 'react';
import Article1 from '../components/Article1';
import Article2 from '../components/Article2';
import Welcome from '../components/Welcome';
import Article3 from '../components/Article3';
import Article4 from '../components/Article4';
import Article5 from '../components/Article5';
import Article6 from '../components/Article6';

const Home = () => {

    const [height,setHeight] = useState();

    useEffect(()=>{
        setHeight(window.innerHeight);
        window.addEventListener('resize',() => setHeight(window.innerHeight))
        return () => window.removeEventListener('resize', () => setHeight(window.innerHeight))
    },[])


    return (
        <div>
            <Article1 />
            <Article2 />
            <Welcome/>
            <Article3 art1height={height} />
            <Article4 />
            <Article5 />
            <Article6 />
        </div>
    );
};

export default Home;